import { useFormik } from "formik";
import { Button } from "primereact/button";
import React from "react";
import { useDispatch } from "react-redux";
import * as Yup from "yup";
import { useTranslation } from "@i18n/hooks";
import { type AcademiesTagFormProps, type AcademiesTagFormState } from "./academies-tag-form.types";
import {
	DefaultSwitchComponent,
	DefaultTextFieldComponent,
} from "../../../../components/DefaultTextInput";
import { ValidatedField } from "../../../../components/ValidatedField";
import { addEditedFormToEditedFormsArray } from "../../../../store/slices/CoreSlice";

export const AcademiesTagForm = ({ onSubmit, initialValues, isLoading }: AcademiesTagFormProps) => {
	const dispatch = useDispatch();
	const { t } = useTranslation(["common", "validation"]);

	const formId = "AcademiesTagForm";

	const formik = useFormik<AcademiesTagFormState>({
		initialValues: {
			name: initialValues?.name || "",
			isTopic: initialValues?.isTopic || false,
			isClickable: initialValues?.isClickable || false,
		},
		validationSchema: Yup.object().shape({
			name: Yup.string().required(t("validation:required")),
			isClickable: Yup.boolean().required(t("validation:required")),
			isTopic: Yup.boolean().required(t("validation:required")),
		}),
		onSubmit,
	});

	return (
		<form onSubmit={formik.handleSubmit} className="p-fluid">
			<ValidatedField<AcademiesTagFormState, string>
				name="name"
				label={t("common:academiesTags.form.name")}
				component={DefaultTextFieldComponent}
				onChange={() => dispatch(addEditedFormToEditedFormsArray({ form: formId }))}
				formikConfig={formik}
			/>

			<ValidatedField<AcademiesTagFormState, boolean>
				name="isClickable"
				label={t("common:academiesTags.form.isClickable")}
				component={DefaultSwitchComponent}
				onChange={() => dispatch(addEditedFormToEditedFormsArray({ form: formId }))}
				formikConfig={formik}
			/>

			<ValidatedField<AcademiesTagFormState, boolean>
				name="isTopic"
				label={t("common:academiesTags.form.isTopic")}
				component={DefaultSwitchComponent}
				onChange={() => dispatch(addEditedFormToEditedFormsArray({ form: formId }))}
				formikConfig={formik}
			/>

			<Button
				disabled={isLoading}
				type="submit"
				label={t("common:academiesTags.form.save")}
				className="p-mt-2"
			/>
		</form>
	);
};
